/* global axios */

export default {
  getCarts(accountId, params = {}) {
    return axios.get(`/api/v1/accounts/${accountId}/carts`, { params });
  },

  getCart(accountId, cartId) {
    return axios.get(`/api/v1/accounts/${accountId}/carts/${cartId}`);
  },
};
